const TEXT_ALIGN_VALUES = new Set(['left', 'center', 'right', 'justify'])

function getStyleTextAlign(attrs: string): string | null {
  const styleMatch = attrs.match(/\sstyle\s*=\s*(['"])(.*?)\1/i)
  if (!styleMatch) return null

  const styleValue = styleMatch[2]
  const alignMatch = styleValue.match(/text-align\s*:\s*([a-z-]+)/i)
  if (!alignMatch) return null

  const align = alignMatch[1].toLowerCase()
  return TEXT_ALIGN_VALUES.has(align) ? align : null
}

function getHref(attrs: string): string | null {
  const quotedHrefMatch = attrs.match(/\shref\s*=\s*(['"])(.*?)\1/i)
  if (quotedHrefMatch) return quotedHrefMatch[2]

  const bareHrefMatch = attrs.match(/\shref\s*=\s*([^\s>]+)/i)
  if (bareHrefMatch) return bareHrefMatch[1]

  return null
}

function replaceNbspEntities(html: string): string {
  return html
    .replace(/\u00A0/g, ' ')
    .replace(/&(?:amp;)*nbsp;/gi, ' ')
    .replace(/&#160;/g, ' ')
    .replace(/&#x0*a0;/gi, ' ')
}

export function normalizeRichTextHtml(
  input: string | null | undefined
): string {
  if (!input) return ''

  let html = replaceNbspEntities(input.trim())
  if (!html) return ''

  html = html
    .replace(/<br\s*\/?>/gi, '<br>')
    .replace(/<div(\s[^>]*)?>/gi, (_, attrs = '') => `<p${attrs}>`)
    .replace(/<\/div>/gi, '</p>')
    .replace(/<b(\s[^>]*)?>/gi, '<strong$1>')
    .replace(/<\/b>/gi, '</strong>')
    .replace(/<i(\s[^>]*)?>/gi, '<em$1>')
    .replace(/<\/i>/gi, '</em>')
    .replace(/<font\b[^>]*>/gi, '')
    .replace(/<\/font>/gi, '')

  html = html.replace(/<(p|h1|h2|h3)(\s[^>]*)?>/gi, (full, tag, attrs = '') => {
    const align = getStyleTextAlign(attrs)
    if (!align) return `<${tag.toLowerCase()}>`
    return `<${tag.toLowerCase()} style="text-align: ${align};">`
  })

  html = html.replace(/<a(\s[^>]*)?>/gi, (full, attrs = '') => {
    const href = getHref(attrs)
    if (!href) return '<a>'
    return `<a href="${href.replace(/"/g, '&quot;')}">`
  })

  return html
}

export function isEmptyRichTextHtml(input: string | null | undefined): boolean {
  if (!input) return true

  const normalized = normalizeRichTextHtml(input)
  if (!normalized) return true

  const withoutBreaks = normalized.replace(/<br>/gi, '')
  const withoutTags = withoutBreaks.replace(/<[^>]*>/g, '')
  const withoutNbsp = withoutTags.replace(/&nbsp;/gi, ' ')
  return withoutNbsp.trim().length === 0
}
